import { render } from "./HazardEditor.vue?vue&type=template&id=63777162"
import script from "./HazardEditor.vue?vue&type=script&lang=js"
export * from "./HazardEditor.vue?vue&type=script&lang=js"

import "./HazardEditor.vue?vue&type=style&index=0&id=63777162&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__